export const AttributeTypes = Object.freeze({
    HEADING: 1,
    SUB_HEADING: 2,
    STATIC_TEXT: 3,
    INPUT_TEXT: 4,
    NUMBER: 5,
    LONG_INPUT_TEXT: 6,
    DATE: 7,
    DROP_DOWN: 8,
    MULTI_DROP_DOWN: 9,
    RADIO: 10,
    CHECKBOX: 11,
    DURATION: 12,
});

export const UserProfileTypes = Object.freeze({
    NORMAL: 'normal',
    USER_PROFILE: 'user_profile',
    BOTH: 'both',
});

export const AttributePropertyTypes = Object.freeze({
    NORMAL: 'normal',
    TAGGED: 'tagged',
});

export const AttributeSubmissionTypes = Object.freeze({
    TAGGED: 'tagged',
    COMPANY: 'company',
    SHARED: 'shared',
});

export const AttributeRules = Object.freeze({
    MINIMUM_VALUE: 'minimumValue',
    MAXIMUM_VALUE: 'maximumValue',
    MINIMUM_LENGTH: 'lengthMin',
    MAXIMUM_LENGTH: 'lengthMax',
});

export const AttributeIcons = Object.freeze({
    ICON_1: 'pi-align-center',
    ICON_2: 'pi-align-justify',
    ICON_3: 'pi-align-left',
    ICON_4: 'pi-align-right',
    ICON_5: 'pi-amazon',
    ICON_6: 'pi-bars',
    ICON_7: 'pi-angle-double-down',
    ICON_8: 'pi-angle-double-left',
    ICON_9: 'pi-angle-double-right',
    ICON_10: 'pi-angle-double-up',
    ICON_11: 'pi-angle-down',
    ICON_12: 'pi-angle-up',
    ICON_13: 'pi-angle-left',
    ICON_14: 'pi-angle-right',
    ICON_15: 'pi-arrow-circle-down',
    ICON_16: 'pi-arrow-circle-up',
    ICON_17: 'pi-arrow-circle-left',
    ICON_18: 'pi-arrow-circle-right',
    ICON_19: 'pi-arrow-down',
    ICON_20: 'pi-arrow-up',
    ICON_21: 'pi-arrow-left',
    ICON_22: 'pi-arrow-right',
    ICON_23: 'pi-briefcase',
    ICON_24: 'pi-arrow-down-left',
    ICON_25: 'pi-arrow-down-right',
    ICON_26: 'pi-arrow-up-left',
    ICON_27: 'pi-arrow-up-right',
    ICON_28: 'pi-building',
    ICON_29: 'pi-arrows-h',
    ICON_30: 'pi-arrows-v',
    ICON_31: 'pi-at',
    ICON_32: 'pi-backward',
    ICON_33: 'pi-forward',
    ICON_34: 'pi-th-large', //
    ICON_35: 'pi-globe',
    ICON_36: 'pi-google',
    ICON_37: 'pi-hashtag',
    ICON_38: 'pi-heart',
    ICON_39: 'pi-heart-fill',
    ICON_40: 'pi-history',
    ICON_41: 'pi-home',
    ICON_42: 'pi-sun',
    ICON_43: 'pi-id-card',
    ICON_44: 'pi-image',
    ICON_45: 'pi-images',
    ICON_46: 'pi-inbox',
    ICON_47: 'pi-info',
    ICON_48: 'pi-info-circle',
    ICON_49: 'pi-instagram',
    ICON_50: 'pi-key',
    ICON_51: 'pi-sync',
    ICON_52: 'pi-link',
    ICON_53: 'pi-linkedin',
    ICON_54: 'pi-list',
    ICON_55: 'pi-lock',
    ICON_56: 'pi-lock-open',
    ICON_57: 'pi-map',
    ICON_58: 'pi-map-marker',
    ICON_59: 'pi-table',
    ICON_60: 'pi-tablet',
    ICON_61: 'pi-microsoft',
    ICON_62: 'pi-paperclip',
    ICON_63: 'pi-pause',
    ICON_64: 'pi-paypal',
    ICON_65: 'pi-pencil',
    ICON_66: 'pi-percentage',
    ICON_67: 'pi-phone',
    ICON_68: 'pi-play',
    ICON_69: 'pi-plus',
    ICON_70: 'pi-plus-circle',
    ICON_71: 'pi-pound',
    ICON_72: 'pi-power-off',
    ICON_73: 'pi-prime',
    ICON_74: 'pi-print',
    ICON_75: 'pi-qrcode',
    ICON_76: 'pi-question',
    ICON_77: 'pi-question-circle',
    ICON_78: 'pi-reddit',
    ICON_79: 'pi-refresh',
    ICON_80: 'pi-replay',
    ICON_81: 'pi-reply',
    ICON_82: 'pi-save',
    ICON_83: 'pi-search',
    ICON_84: 'pi-search-minus',
    ICON_85: 'pi-search-plus',
    ICON_86: 'pi-send',
    ICON_87: 'pi-server',
    ICON_88: 'pi-tag',
    ICON_89: 'pi-tags',
    ICON_90: 'pi-shopping-bag',
    ICON_91: 'pi-shopping-cart',
    ICON_92: 'pi-sign-in',
    ICON_93: 'pi-sign-out',
    ICON_94: 'pi-sitemap',
    ICON_95: 'pi-slack',
    ICON_96: 'pi-sliders-h',
    ICON_97: 'pi-sliders-v',
    ICON_98: 'pi-sort',
    ICON_99: 'pi-sort-alpha-down',
    ICON_100: 'pi-sort-alpha-down-alt',
    ICON_101: 'pi-sort-alpha-up',
    ICON_102: 'pi-sort-alpha-up-alt',
    ICON_103: 'pi-sort-alt',
    ICON_104: 'pi-sort-alt-slash',
    ICON_105: 'pi-sort-amount-down',
    ICON_106: 'pi-sort-amount-down-alt',
    ICON_107: 'pi-sort-amount-up',
    ICON_108: 'pi-sort-amount-up-alt',
    ICON_109: 'pi-sort-down',
    ICON_110: 'pi-sort-numeric-down',
    ICON_111: 'pi-sort-numeric-down-alt',
    ICON_112: 'pi-sort-numeric-up',
    ICON_113: 'pi-sort-numeric-up-alt',
    ICON_114: 'pi-sort-up',
    ICON_115: 'pi-shield',
    ICON_116: 'pi-spinner',
    ICON_117: 'pi-star',
    ICON_118: 'pi-star-fill',
    ICON_119: 'pi-step-backward',
    ICON_120: 'pi-step-forward',
});
